import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';

const initialState = {
    data: {
        recruitFrom: moment().format('YYYY-MM-DD HH:mm:ss'),
        recruitEnd: moment().add(7, 'days').format('YYYY-MM-DD HH:mm:ss'),
        changeInfo: 'N',
        recruitClass: '',
        recruitLicense: '',
        recruitForm: '',
        recruitNum: '',
        recruitPosition: '',
        recruitPay: '',
        recruitPayEtc: '',
        recruitGrade: '',
        recruitGradeEtc: '',
        recruitCareer: '',
        recruitCareerYear: '',
        recruitDetails: '',
        recruitClassInfo: '',
        recruitDay: '',
        recruitDayEtc: '',
        recruitTime: '',
        assist1: '',
        assist2: '',
        assist3: '',
        assist4: '',
        assist5: '',
        conditionEtc: '',
        applyMethod1: '001',
        applyMethod2: '',
        applyMethod3: '',
        applyMethod4: '',
        applyMethod5: '',
        needPaper: '',
        needPaperEtc: '',
        recruitFlow: '',
        proposeSMS: '',
        title: '',
        contents: '',
        applyMethod002: '',
        phoneNumber: '',
        applyMethod003: '',
        email: '',
        applyMethod004: '',
        fax: '',
        applyMethod005: '',
        address: '',
        recruitCareerYearFrom: '',
        recruitCareerYearTo: '',
        recruitFlowCheck1: '',
        recruitFlowCheck2: '',
        recruitFlowCheck3: '',
        recruitFlowText1: '',
        recruitFlowText2: '',
        recruitFlowText3: '',
        recruitFlowTextOpen1: '',
        recruitFlowTextOpen2: '',
        recruitFlowTextOpen3: '',
    },
};

const PAJAC020Slice = createSlice({
    name: 'dataPAJAC020',
    initialState,
    reducers: {
        updateData: (state, action) => {
            state.data = { ...state.data, ...action.payload };
        },
        resetData: (state) => {
            state.data = initialState.data;
        },
    },
});

export const { updateData, resetData } = PAJAC020Slice.actions;
export default PAJAC020Slice.reducer;
